const messages = {
    en: {
      timeLeft: "Time left",
      seconds: "sec",
    },
    ru: {
      timeLeft: "Оставшееся время",
      seconds: "сек",
    }
  };

  export default messages;